import { useQuery } from '@tanstack/react-query'
import { accessControlApi } from '../api/access-control.client'

export const roleDetailQueryKey = (roleId: string) =>
  ['access-control', 'roles', roleId] as const

export function useRoleDetailQuery(roleId: string) {
  return useQuery({
    queryKey: roleDetailQueryKey(roleId),
    queryFn: () => accessControlApi.getRoleDetail(roleId),
    enabled: !!roleId,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
